class TabsElement extends HTMLElement {
  constructor() {
    super();
    this.tabLinks = this.querySelectorAll('.js-tab-links');
    this.tabContents = this.querySelectorAll('.js-tab-content');
  }

  connectedCallback() {
    // Initialize the tabs functionality
    this.tabLinks.forEach(link => {
      link.addEventListener('click', (e) => this.handleTabClick(e));
    })
  }

  handleTabClick(evt) {
    evt.preventDefault();

    const targetTab = evt.currentTarget.getAttribute('data-tab');

    this.tabLinks.forEach(link => {
      link.classList.remove('active');
    });
    evt.currentTarget.classList.add('active');
    evt.currentTarget.scrollIntoView({ behavior: 'smooth', block: "nearest", container: "nearest", inline: 'start' });

    this.tabContents.forEach(content => {
      content.classList.remove('active');
      if (content.getAttribute('data-content-id') === targetTab) {
        content.classList.add('active');
      }
    });
  }
}

if (!customElements.get('tabs-element')) {
  customElements.define('tabs-element', TabsElement);
}